import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  PerplayRankApi
} from '../../models/src';
import {
  RANK_SYSTEM_LIST_REQUEST,
  RANK_SYSTEM_UPDATE_REQUEST,
} from '../../constants/app/inAppRankSystemConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import PerplayRankControllerDtoRankDetailSettingListResponse
  from '../../models/src/model/PerplayRankControllerDtoRankDetailSettingListResponse';
import PerplayRankControllerDtoRankDetailSettingUpdateResponse
  from '../../models/src/model/PerplayRankControllerDtoRankDetailSettingUpdateResponse';
import PerplayRankControllerDtoRankDetailSettingUpdateRequest
  from "../../models/src/model/PerplayRankControllerDtoRankDetailSettingUpdateRequest";

const api = new PerplayRankApi(config.API_CLIENT);

function* inAppRankSystemListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    // const requestData = '';
    console.log('요청 데이터: ', payload);

    const result = yield api.apiPerplayRankRankDetailSettingListPost(() => {});
    const data = api.apiClient.deserialize(result, PerplayRankControllerDtoRankDetailSettingListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* inAppRankSystemUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new PerplayRankControllerDtoRankDetailSettingUpdateRequest();
    requestData.settingNo = payload.settingNo;
    requestData.rankType = payload.rankType;
    requestData.lastRank = payload.lastRank;
    requestData.targetType = payload.targetType;
    requestData.withoutTarget = payload.withoutTarget;
    requestData.rankDetail = payload.rankDetail;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayRankRankDetailSettingUpdatePost({ rankControllerDtoRankDetailSettingUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, PerplayRankControllerDtoRankDetailSettingUpdateResponse)

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    if(data.code !== "Success") {
      console.log("success!");
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* inAppRankSystemRootSaga() {
  yield all([
    takeEvery(RANK_SYSTEM_LIST_REQUEST, inAppRankSystemListRequestSaga),
    takeEvery(RANK_SYSTEM_UPDATE_REQUEST, inAppRankSystemUpdateRequestSaga),
  ])
}

const inAppRankSystemSaga = [
  fork(inAppRankSystemRootSaga),
];

export default inAppRankSystemSaga;
